const formats = [
  {
    icon: 'ri-flashlight-line',
    title: 'Корпоративные тренинги',
    desc: 'Практическое обучение команд по конкретным компетенциям с отработкой навыков в реальных ситуациях.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Модульные программы',
    desc: 'Несколько этапов обучения с практикой между встречами, когда навыки закрепляются в работе постепенно.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Индивидуальные программы',
    desc: 'Программа под конкретную категорию сотрудников или задачу компании.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Наставничество',
    desc: 'Развитие сотрудников непосредственно в рабочем процессе через передачу опыта и обратную связь.',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Практическая отработка навыков в моделируемых ситуациях с высокой вовлечённостью.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Коучинг',
    desc: 'Индивидуальная работа с руководителями и сотрудниками по конкретным задачам развития.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение',
    desc: 'Поддержка внедрения после обучения, чтобы новые навыки закрепились в работе.',
  },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Форматы развития персонала
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Не существует одного универсального формата. Выбор определяется задачами компании, уровнем сотрудников и глубиной необходимых изменений.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {formats.map((f, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${f.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-gray-500 mt-8 max-w-3xl mx-auto leading-relaxed">
          Ни один из форматов не является обязательным — формат подбирается под задачу, а не наоборот.
        </p>
      </div>
    </section>
  );
}